webpackJsonp([35783957827783],{

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Key Value'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Software engineering from the South East of England.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/contact' },
	        'Contact us'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      {
	        style: {
	          fontSize: '0.6em',
	          fontStyle: 'italic'
	        }
	      },
	      'This website is currently being built, so check us out again soon when we\'re at our best.'
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f2c06352c621f7e3eeb2.js